import React, { useState, useEffect } from 'react';
import { Table, Pagination, Checkbox } from 'rsuite';
import './other-bm-accounts.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../../utils/i18n';
import { Popover, Whisper, Dropdown } from 'rsuite';
import { AddAccountsManually, AddAccountsExcel } from '../../molecules';

function OtherBMAccounts({ accounts, accountId, handleSuccessAdccounts }) {
  const { Column, HeaderCell, Cell } = Table;
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [adAccountsManually, setAddAccontsManually] = useState(false);
  const [adAccountsExcel, setAddAccountsExcel] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [addAccountsModal, setAddAccountsModal] = useState(false);

  const triggerRef = React.useRef();

  useEffect(() => {
    accounts.forEach(res => {
      res.checked = false;
    });
  }, []);

  const getWidth = (value = 6) => {
    return window.innerWidth / value;
  };

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };

  const pageChange = page => {
    setPage(page);
  };

  const handleAdd = key => {
    if (key === '1') {
      setAddAccontsManually(true);
    } else if(key === '2') {
      handleExcelModal(true);
    }
    triggerRef.current.close();
  };

  const getData = () => {
    let data = accounts?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
    return data;
  };

  const StatusCell = ({ rowData, onChange, dataKey, ...props }) => (
    <Cell {...props}>
      <div>
        {rowData.accountStatus === 1 ? (
          <span>{t('Active')}</span>
        ) : rowData[dataKey] === -1 ? (<span>{t('In progress')}</span>): (
          <span>{t('admin.status.inactive')}</span>
        )}
      </div>
    </Cell>
  );

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: '46px' }} className={rowData.is_imported ? 'disabled' : null}>
        <Checkbox value={rowData} inline onChange={onChange} checked={rowData[dataKey]} disabled={rowData.onboardingStatus === "IN_PROGRESS"} />
      </div>
    </Cell>
  );

  const handleCheck = (value, checked) => {
    accounts.find(ac => ac.accountId === value.accountId).checked = checked;
    let selAccounts = [];
    accounts.forEach(res => {
      if (res?.checked) {
        selAccounts.push(res);
      }
    });
    setSelectedAccounts([...selAccounts]);
  };

  const onClearAccound = (e, item) => {
    item.checked = false;
    handleCheck(item, false);
  };

  const handleOpenSliderModal = (val, isSuccess = false) => {
    if(isSuccess) {
      handleSuccessAdccounts(true)
    }
    setAddAccountsModal(val);
  };

  const handleExcelModal = (val, isSuccess = false) => {
    if(isSuccess) {
      handleSuccessAdccounts(true)
    }
    setAddAccountsExcel(val);
  }

  const onAdd = () => {
    setAddAccountsModal(true);
  };

  const onClose = () => {
    setAddAccontsManually(false);
  }

  return (
    <div>
      {adAccountsManually && (
        <div>
          <div className="campaigns-list-container accounts-manually">
            <div className="list-scroll-container">
              <div className="selected-campaigns sel_accounts">
                {t('define.metric.selectedAdAcc')}({selectedAccounts?.length})
              </div>
              <div className="list-scroll">
                <div className="selected-list list_val">
                  {selectedAccounts?.map(item => {
                    return (
                      <div className="selected-item" key={item.accountId}>
                        <span className="selected-value" title={item?.accountId}>
                          {item?.accountId}
                        </span>
                        <span className="cross" onClick={e => onClearAccound(e, item)}>
                          <i className="eva eva-close-outline clear-icon"></i>
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="add-account">
        {adAccountsManually && (
          <div className="add-btn">
            <button className="step-back" onClick={onClose}>{t('admin.add.close')}</button>
            <button className="step-back step-add" onClick={onAdd}>
              {t('admin.adaccount.add')}
            </button>
          </div>
        )}
        {!adAccountsManually && (
          <div className="round">
            <Whisper
              placement="leftStart"
              trigger={'click'}
              ref={triggerRef}
              speaker={
                <Popover className={'className'} full>
                  <Dropdown.Menu onSelect={handleAdd}>
                    <Dropdown.Item eventKey={'1'}>{t('admin.select.manually')}</Dropdown.Item>
                    <Dropdown.Item eventKey={'2'}>{t('admin.add.excel')}</Dropdown.Item>
                  </Dropdown.Menu>
                </Popover>
              }
            >
              <span>{t('admin.add.account')}</span>
            </Whisper>
          </div>
        )}
      </div>

      <div>
        <Table autoHeight data={getData(3)} bordered cellBordered className="admin-table">
          {adAccountsManually && (
            <Column width={50} fixed align="center">
              <HeaderCell style={{ padding: 0 }}></HeaderCell>
              <CheckCell dataKey="checked" onChange={handleCheck} />
            </Column>
          )}
          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.account.id')}</HeaderCell>
            <Cell dataKey="accountId" />
          </Column>

          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.ac.name')}</HeaderCell>
            <Cell dataKey="accountName" />
          </Column>

          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.ac.onboardstatus')}</HeaderCell>
            <Cell dataKey="onboardingStatus" />
          </Column>
          <Column width={getWidth(4)}>
            <HeaderCell>{t('Status')}</HeaderCell>
            <StatusCell dataKey="accountStatus" />
          </Column>
        </Table>
      </div>
      <div className="pagination-div">
        <span>{t('reports.per.page')}</span>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          layout={['-', 'limit', '|', 'pager']}
          total={accounts?.length}
          limitOptions={[10, 15]}
          limit={limit}
          activePage={page}
          onChangePage={page => {
            pageChange(page);
          }}
          onChangeLimit={handleChangeLimit}
        />
      </div>
      {addAccountsModal && (
        <AddAccountsManually
          addAccountsModal={addAccountsModal}
          handleOpenSliderModal={handleOpenSliderModal}
          selectedAccounts={selectedAccounts}
          accountId={accountId}
          onRemove={onClearAccound}
        />
      )}
      {adAccountsExcel && (
        <AddAccountsExcel
        addAccountsModal={adAccountsExcel}
        handleOpenSliderModal={handleExcelModal}
        />
      )}

    </div>
  );
}
export default OtherBMAccounts;
